import { Component, OnInit, ElementRef, AfterViewInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LsFileUploadService } from '../ls-file-upload.service';
import { LsDropFileDirective } from '../../../directives/ls-drop-file/ls-drop-file.directive';
import { LsSnackbarService } from '../../ls-snackbar/ls-snackbar.service';
/**
 * Displays the Image Uploader
 */
@Component({
  selector: 'ls-image-upload',
  templateUrl: './ls-image-upload.component.html',
  styleUrls: ['./ls-image-upload.component.css'],
  providers: [LsFileUploadService]
})
export class LsImageUploadComponent implements OnInit, AfterViewInit {

  allowExtensions = ['pdf', 'odt', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png'];
  blockExtensions = ['.jar', '.war', '.zip', '.rar', '.exe', '.tar', '.7z', '.iso', '.php', '.swf', '.html', '.js',]

  /**
   * Render Reference for Canvas
   */
  context: CanvasRenderingContext2D;
  /**
   * Constructor
   * @param element 
   * @param dom 
   * @param uploadServices 
   */
  public constructor(private element: ElementRef, private snackBar: LsSnackbarService,
    private dom: DomSanitizer, private uploadServices: LsFileUploadService) { }

  /**
   * Canvas CSS Display property
   */
  canvasDisplay = "none";
  /**
   * Reference of Render image canvas 
   */
  @ViewChild("myCanvas") myCanvas;
  /**
   * Reference of Image Drop Canvas
   */
  @ViewChild("dropCanvas") dropCanvas;
  /**
   * Image File
   */
  fileImage;
  /**
   * Image Upload type
   */
  @Input('imgUpType') imageDrop
  /**
   * Max Image Upload Size
   */
  @Input('imageSize') imageSize
  /**
   * Width of Image
   */
  @Input('width') width
  /**
   * Height of Image
   */
  @Input('height') height
  /**
   * Image upload Event emitter
   */
  @Output("files") files = new EventEmitter();
  /**
   * @ignore
   */
  resultValue;
  /**
   * Image to be render on the CANVAS
   */
  image: File;
  /**
   * Display controller of upload button.
   */
  buttonHide = "hidden";
  /**
   * If Image Type 3 Canvas is Emptied.
   */
  ngOnInit() {
    // if(this.imageDrop==3)
    // this.draw(null);
  }
  /**
   * Click Event Emitter on the image upload reference
   */
  onClick() {
    this.element.nativeElement.querySelector("#lsimageupload").click();

  }
  /**
   * 1. Selects the Image uploaded on the image uploader.
   * 2. Draws the Image on the canvas.
   * 3. If Button is hidden, display's the button.
   * 4. If uploader type is 3, emits the file.
   */
  selectImage() {
    let files = this.element.nativeElement.querySelector('#lsimageupload').files;
    let file = files[0];
    this.fileImage = file;

    this.acceptedFiles(this.fileImage).then((resp) => {
      if (resp && resp == 'valid') {
        // console.log("first valid", this.fileImage);
        
        this.buttonHide = "visible";
        if (this.imageDrop != 4)
          this.draw(this.fileImage);

        if (this.imageDrop == 3 || this.imageDrop == 4)
          this.files.emit(this.fileImage)
      } else {
        this.snackBar.open('Invalid File Extension', '', 2000);
      }
    });
  }

  /**
   * @ignore
   */
  ngAfterViewInit() {
  }
  /**
   * @ignore
   */
  b;
  /**
   * Draws the Image on the canvas according image ratio.
   * @param image 
   */
  draw(image) {

    let canvas;
    if (this.imageDrop == '2') {
      canvas = this.dropCanvas.nativeElement;
      this.context = canvas.getContext("2d");
    }
    else {
      canvas = this.myCanvas.nativeElement;
      this.context = canvas.getContext("2d");
    }
    let tempContext = this.context;
    let img = new Image();
    let size = this.imageSize;
    img.onload = function () {
      let ratio = img.height / img.width;
      let width = size;
      let height = size * ratio;
      canvas.width = width;
      canvas.height = height;
      tempContext.drawImage(img, 0, 0, width, height);
    }
    img.src = URL.createObjectURL(image);
    this.canvasDisplay = "block";
  }

  /**
   * Image Drag -> Drop event handler. Draws the Image.
   * @param value 
   */
  uploadDragFiles(value) {
    this.buttonHide = "visible"
    this.fileImage = value[0];
    this.draw(this.fileImage);
  }


  /**
   * Upload event handler
   */
  upload() {
    let files: Array<any> = new Array<any>();
    files.push(this.fileImage);
    this.files.emit(files)
  }



  // Block malicious files

  /**
     * blocks the not allowed extensions
     * @param fileName 
     */
  acceptedFiles(file: File) {
    return new Promise((resolve, reject) => {
      let isFileValid = false;
      if (file.name.split('.').length > 2) {
        return 'File Name is Invalid'
      }
      for (let i = 0; i < this.allowExtensions.length; i++) {
        if (file.name.split('.')[1] == this.allowExtensions[i] || file.type.includes(this.allowExtensions[i])) {
          // console.log("first", this.allowExtensions[i]);
          isFileValid = true;
          break;
        }
      }
      if (isFileValid) {
        this.internalFileValid(file).then((resp: any) => {
          if (resp) {
            resolve('valid');
          }
        }, err => {
          this.snackBar.open('Invalid File', '', 2000);
          resolve("Unsupported File Type.");
        })

      } else {
        this.snackBar.open('Invalid File', '', 2000);
        resolve("Unsupported File Type.");
      }

    })
  }


  internalFileValid(file) {
    return new Promise((resolve, reject) => {
      let blob: File = file
      let header = '';
      let fileReader = new FileReader

      fileReader.onloadend = () => {
        let arr = new Uint8Array(fileReader.result as Iterable<any>).subarray(0, 12);
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }
        let buffer = header.toLowerCase();
        console.log("complete header string", buffer);

        // pdf, png, jpg/jpeg, doc/xls, docx/xlsx~jar~zip
        // || buffer.substring(0, 8) == '504b0304'
        if (buffer.substring(0, 8) == '89504e47' || buffer.substring(0, 4) == 'ffd8') {
          resolve(true);
        } else {
          reject(false)
        }
        //exe
        // if (buffer.substring(0, 4) == '5A4D' || buffer.substring(0, 4) == '4D5A') {
        //   reject(false)
        // } else {
        //   resolve(true);
        // }

      }
      fileReader.readAsArrayBuffer(blob)
    })
  }





}
